/* ═══════════════════════════════════════════════════════════
   Pro Chef Israel — Chat Widget JS v5.3
   ───────────────────────────────────────────────────────────
   V5.3: Clean & fast. Removed nav-state persistence and
         history panel (were causing perf issues).
         Notifications + styled CTAs preserved.
   ═══════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var C = window.__FC || {};
  var API = C.api || '';
  var WA = C.wa || '';
  var GRT = C.greeting || '';
  var WAT = C.waText || '';
  var BRAND = C.brand || 'פרו שף ישראל';

  /* ── State ── */
  var isOpen = false, greeted = false, sending = false;
  var sid = 'fc_' + rnd();
  var currentMessages = [];
  var unreadCount = 0;

  /* ── DOM refs ── */
  var fab, fabL, ov, zone, msgs, inp, snd, xBtn, pills, pillC;
  var imgB, fileI, notifBadge, toast;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    fab = $('fc-fab');
    fabL = $('fc-fab-label');
    ov = $('fc-ov');
    zone = $('fc-zone');
    msgs = $('fc-msgs');
    inp = $('fc-inp');
    snd = $('fc-snd');
    xBtn = $('fc-x');
    pillC = $('fc-pills');
    imgB = $('fc-imgb');
    fileI = $('fc-fi');
    notifBadge = $('fc-notif-badge');
    toast = $('fc-toast');
    pills = document.querySelectorAll('.fc-pill');

    if (!fab || !zone) return;

    bindEvents();
    initKeyboard();
  }

  function bindEvents() {
    fab.onclick = function () {
      if (isOpen) closeChat();
      else { clearNotifications(); openChat(); }
    };
    xBtn.onclick = closeChat;
    ov.onclick = closeChat;

    snd.onclick = function () { sendMsg(inp.value); };
    inp.onkeydown = function (e) {
      if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendMsg(inp.value); }
    };

    pills.forEach(function (p) {
      p.onclick = function () { sendMsg(p.dataset.q, true); };
    });

    imgB.onclick = function () { fileI.click(); };
    fileI.onchange = onImageSelect;

    if (toast) {
      toast.onclick = function () { clearNotifications(); openChat(); };
    }
  }

  /* ═══ Open / Close ═══ */
  function openChat() {
    isOpen = true;
    zone.classList.add('fc-vis');
    ov.classList.add('fc-vis');
    fab.classList.add('fc-open');
    if (fabL) fabL.classList.add('fc-hide');
    pills.forEach(function (p) { p.classList.add('fc-in'); });
    setTimeout(function () { inp.focus(); }, 350);
    clearNotifications();

    if (!greeted) {
      greeted = true;
      setTimeout(function () { addBot(GRT); }, 300);
    }
  }

  function closeChat() {
    isOpen = false;
    zone.classList.remove('fc-vis');
    zone.classList.remove('fc-kb');
    ov.classList.remove('fc-vis');
    fab.classList.remove('fc-open');
    if (fabL) fabL.classList.remove('fc-hide');
  }

  /* ═══ Notifications ═══ */
  function showNotification(text) {
    if (isOpen) return;
    unreadCount++;

    if (notifBadge) {
      notifBadge.textContent = unreadCount > 9 ? '9+' : unreadCount;
      notifBadge.classList.add('fc-show');
    }

    if (toast) {
      var preview = stripHtml(text).substring(0, 80);
      toast.innerHTML =
        '<div class="fc-toast-hdr">' +
          '<span class="fc-toast-dot"></span>' +
          '<span class="fc-toast-name">' + esc(BRAND) + '</span>' +
        '</div>' +
        '<div class="fc-toast-msg">' + esc(preview) + '</div>';
      toast.classList.add('fc-show');

      clearTimeout(toast._timer);
      toast._timer = setTimeout(function () {
        toast.classList.remove('fc-show');
      }, 6000);
    }
  }

  function clearNotifications() {
    unreadCount = 0;
    if (notifBadge) notifBadge.classList.remove('fc-show');
    if (toast) {
      toast.classList.remove('fc-show');
      clearTimeout(toast._timer);
    }
  }

  /* ═══ Send ═══ */
  function sendMsg(text, skipTyping) {
    text = (text || '').trim();
    if (!text || sending) return;
    sending = true;

    addUser(text);
    pillC.style.display = 'none';
    inp.value = '';
    inp.focus();
    if (!skipTyping) showTyping();

    fetch(API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ message: text, session_id: sid })
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!skipTyping) hideTyping();
        sending = false;
        var reply = d.reply ? fmt(d.reply) : 'משהו השתבש, נסה שוב 🙏';
        addBot(reply);
        showNotification(d.reply || reply);
      })
      .catch(function () {
        if (!skipTyping) hideTyping();
        sending = false;
        addBot('בעיית תקשורת, נסה שוב 🙏');
      });
  }

  function onImageSelect(e) {
    var f = e.target.files[0];
    if (!f) return;
    var r = new FileReader();
    r.onload = function (ev) {
      addRaw('<img class="fc-ci" src="' + ev.target.result + '" alt="תמונה" width="180" height="140">', 'u');
      sendMsg('שלחתי תמונה, אשמח להתייעצות');
    };
    r.readAsDataURL(f);
    fileI.value = '';
  }

  /* ═══ SVG Icons ═══ */
  function waIconSvg() {
    return '<svg viewBox="0 0 24 24"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/><path d="M12 0C5.373 0 0 5.373 0 12c0 2.625.846 5.059 2.284 7.034L.789 23.492l4.634-1.215A11.95 11.95 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.75c-2.171 0-4.178-.7-5.813-1.888l-.417-.31-2.75.721.735-2.682-.342-.543A9.72 9.72 0 012.25 12 9.75 9.75 0 0112 2.25 9.75 9.75 0 0121.75 12 9.75 9.75 0 0112 21.75z"/></svg>';
  }
  function productIconSvg() {
    return '<svg viewBox="0 0 24 24"><path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49A1.003 1.003 0 0020 4H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"/></svg>';
  }
  function chefIconSvg() {
    return '<svg viewBox="0 0 24 24"><path d="M12 2C9.24 2 7 4.24 7 7c0 1.53.69 2.9 1.78 3.82C6.55 11.83 5 14.27 5 17v1c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-1c0-2.73-1.55-5.17-3.78-6.18C16.31 9.9 17 8.53 17 7c0-2.76-2.24-5-5-5zm0 2c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 8c2.67 0 5 2.33 5 5v1H7v-1c0-2.67 2.33-5 5-5z"/></svg>';
  }

  /* ═══ Format Bot Reply ═══ */
  function fmt(t) {
    t = t.replace(/https:\/\/wa\.me\/(\d+)(\?text=[^\s)\"<]*)?/g, function (m) {
      return '</span><a class="fc-cta fc-cta-wa" href="' + m + '" target="_blank" rel="noopener">' + waIconSvg() + ' <span>' + WAT + '</span></a><span>';
    });
    t = t.replace(/(?<!href="|">)(https?:\/\/[^\s<)\"]*\/pages\/chef[^\s<)\"]*)/gi, function (m) {
      return '</span><a class="fc-cta fc-cta-chef" href="' + m + '" target="_blank" rel="noopener">' + chefIconSvg() + ' <span>צפה בפרופיל השף</span></a><span>';
    });
    t = t.replace(/(?<!href="|">)(https?:\/\/[^\s<)\"]*\/products\/[^\s<)\"]*)/gi, function (m) {
      return '</span><a class="fc-cta fc-cta-product" href="' + m + '" target="_blank" rel="noopener">' + productIconSvg() + ' <span>צפה במוצר</span></a><span>';
    });
    t = t.replace(/(?<!href="|">)(https?:\/\/(?!wa\.me)[^\s<)\"]+)/g, function (m) {
      return '</span><a class="fc-cta fc-cta-product" href="' + m + '" target="_blank" rel="noopener">' + productIconSvg() + ' <span>קישור ←</span></a><span>';
    });
    t = t.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
    t = t.replace(/\n/g, '<br>');
    return '<span>' + t + '</span>';
  }

  window.fcWhatsApp = function (txt) {
    addBot('<a class="fc-cta fc-cta-wa" href="https://wa.me/' + WA + '" target="_blank" rel="noopener">' + waIconSvg() + ' <span>' + (txt || WAT) + '</span></a>');
  };

  /* ═══ DOM Helpers ═══ */
  function addUser(t) { addRaw(esc(t), 'u'); }
  function addBot(h) { addRaw(h, 'b'); }

  function addRaw(content, type) {
    var div = document.createElement('div');
    div.className = 'fc-m fc-' + type;
    div.innerHTML = content;
    msgs.appendChild(div);
    currentMessages.push({ type: type, html: content });
    scrollDown();
  }

  function scrollDown() {
    requestAnimationFrame(function () { msgs.scrollTop = msgs.scrollHeight; });
  }

  function showTyping() {
    if ($('fc-typing')) return;
    var d = document.createElement('div');
    d.className = 'fc-tp'; d.id = 'fc-typing';
    d.innerHTML = '<div class="fc-td"></div><div class="fc-td"></div><div class="fc-td"></div>';
    msgs.appendChild(d);
    scrollDown();
  }

  function hideTyping() { var t = $('fc-typing'); if (t) t.remove(); }

  function esc(s) {
    return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function stripHtml(h) {
    var tmp = document.createElement('div');
    tmp.innerHTML = h;
    return tmp.textContent || tmp.innerText || '';
  }
  function $(id) { return document.getElementById(id); }
  function rnd() { return Math.random().toString(36).substr(2, 9); }

  /* ═══ Keyboard ═══ */
  function initKeyboard() {
    if (!window.visualViewport) return;
    var origH = window.innerHeight;
    window.visualViewport.addEventListener('resize', function () {
      var h = window.visualViewport.height;
      if ((origH - h) > 100 && isOpen) {
        zone.style.setProperty('--fc-vvh', h + 'px');
        zone.classList.add('fc-kb');
        scrollDown();
      } else {
        zone.classList.remove('fc-kb');
      }
    });
  }

})();